import React, { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Spacing4 } from 'autogen/design-tokens/tokens';
import { OnGeoLocationCallbackContext } from 'components/storeList/shared/helpers';
import { ButtonWithIcon } from 'components/Button';
import mediator from 'modules/mediator';
import { quickViewSearchUseLocationAtom } from '../Atoms/useLocationAtom';
import type { ILocationSearch } from '../shared/types';
import { useRecoilState } from 'recoil';
import Icon from 'components/Icon';
import Loader from 'components/Loader/Loader';

const LocationButton = styled(ButtonWithIcon)`
    position: relative;
    display: block;
    white-space: nowrap;
    font-weight: bold;
    margin-left: auto;
    margin-right: auto;
    padding: ${Spacing4};
    height: unset;
`;

export default function LocationSearch(props: ILocationSearch) {
    const { translations } = props;
    const { errorText } = translations;
    const onGeoLocationCallback = useContext(OnGeoLocationCallbackContext);
    const [useLocation, setUseLocationSearch] = useRecoilState(quickViewSearchUseLocationAtom);
    const [geoLocationLoading, setGeoLocationLoading] = useState<boolean>(false);

    const getGeolocation = useCallback(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const {
                    coords: { latitude, longitude }
                } = position;

                if (onGeoLocationCallback) onGeoLocationCallback(latitude, longitude);
                setGeoLocationLoading(false);
            },
            (error) => {
                mediator.publish('growl', {
                    message: errorText,
                    remove: 5000
                });
                console.warn(error);
            }
        );
    }, []);

    const onClickHandler = useCallback(async (event?) => {
        setGeoLocationLoading(true);

        getGeolocation();
    }, []);

    useEffect(() => {
        if (useLocation) {
            onClickHandler();
        }

        return () => {
            if (useLocation) {
                setUseLocationSearch(false);
            }
        };
    }, [onClickHandler, setUseLocationSearch, useLocation]);

    if (geoLocationLoading) {
        return <Loader size={16} />;
    }

    return <LocationButton variant="primaryText" onClick={onClickHandler} icon={<Icon type="Pin" size={16} />} />;
}
